<template>
  <app-layout>
    <template #header>
      <h2 class="font-bold text-2xl text-gray-800 leading-tight inline-flex">
        <img src="/images/poker.svg" class="h-8 w-8"/>
        <span class="ml-2"> Planning Poker Dashboard</span>
      </h2>
    </template>
    <a-spin style="z-index: 99999;" :spinning="submitting">

      <!-- Delete Token Confirmation Modal -->

      <div class="h-screen flex overflow-hidden">


        <div class="flex flex-col w-0 flex-1 overflow-hidden">

          <main class="flex-1 relative overflow-y-auto focus:outline-none">
            <div class="">

              <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                <bread-nav :pages="pages"></bread-nav>
                <!-- Replace with your content -->
                <div class="py-4">
                  <div v-if="recentRooms.length > 0" class=" ">
                    <ul role="list" class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                      <li v-for="room in recentRooms" :key="room.id"
                          class="col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200">
                        <PokerRoomCard :showConfig="false" :model-value="room" ></PokerRoomCard>
                      </li>
                    </ul>
                  </div>
                  <!-- /End replace -->
                </div>
                <!-- /End replace -->
              </div>
            </div>
          </main>
        </div>
      </div>
    </a-spin>
  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import Button from "@/Jetstream/Button";
import {message} from "ant-design-vue";
import PokerRoomCard from "@/Pages/PlanningPoker/PokerRoomCard";
import JetDangerButton from '@/Jetstream/DangerButton'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import BreadNav from "@/Components/BreadNav/BreadNav";

const pages = [
  {name: 'Planning Poker', href: '#', current: false},
  {name: 'Recently Viewed', href: '#', current: true},
]
export default {
  props: ['recentRooms'],
  data() {
    return {
      submitting: true
    };
  },
  beforeMounted() {

  },
  mounted() {
    this.submitting = false;
  },
  created() {
  },
  setup() {
    return {
      pages
    };
  },

  methods: {
    info(roomKey) {
      let testingCodeToCopy = document.querySelector("#room" + roomKey);
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.select();

      try {
        document.execCommand("copy");
        message.success("Your link is copied");
      } catch (err) {
        message.error("Oops, unable to copy");
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    goToRoom(roomKey) {
      this.$inertia.visit(route("planning-rooms.accessRoom", {id: roomKey}), {
        preserveState: false
      })
    },
    getLink(id) {
      return this.$page.props.env !== 'production' ? 'https://staging.agilesuite.io/rooms/' + id : 'https://agilesuite.io/rooms/' + id;
    },
  },
  components: {
    BreadNav,
    PokerRoomCard,
    JetDangerButton,
    JetSecondaryButton,
    Button,
    AppLayout,
  },
};
</script>
